import { DesignSystem } from "../design-system.js";
import { WizardStep } from "./wizard-step.js";
import { styles } from "./wizard-step.styles.js";
import { template } from "./wizard-step.template.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-wizard-step>
 */
export const definition = WizardStep.compose({
    name: `${DesignSystem.prefix}-wizard-step`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=wizard-step.definition.js.map